import { can, sujet, type Action } from '@artosera/shared/permissions';
import { estRoleConsole, useSession } from './useSession.js';

/**
 * Masque ce que le rôle de la console n'autorise pas (5.4) : la matrice de
 * `@artosera/shared/permissions` est la seule source de vérité, l'API
 * l'appliquera de son côté. Aucune liste de rôles n'est écrite ici : un rôle
 * ajouté à la matrice (l'associé, ARTO-58) est suivi sans toucher au front.
 */
export function usePeut(): (action: Action) => boolean {
  const { moi } = useSession();
  const role = moi?.compte.rolePlateforme;

  return (action: Action): boolean => (estRoleConsole(role) ? can(sujet(role), action) : false);
}
